import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import {
  selectMappedFieldsFilteredByCulture,
  selectSingleFieldOnMap,
} from '../../../slice/selectors';
import DisabledField from '../../fields/DisabledField/DisabledField';
import GeomanEditPolygon from './GeomanEditPolygon';

interface IProps {}

const EditPolygon: FC<IProps> = () => {
  const mappedField = useSelector(selectSingleFieldOnMap);
  const mappedFields = useSelector(selectMappedFieldsFilteredByCulture);

  const disabledFields = mappedFields.filter(
    field => field.id !== mappedField?.id,
  );

  return (
    <>
      <GeomanEditPolygon />

      {disabledFields.map(field => (
        <DisabledField mappedField={field} key={field.id} />
      ))}
    </>
  );
};

export default EditPolygon;
